import { HTMLAttributes } from "react"
import styled from "styled-components"

const StyledDiscountTag = styled.div<{ $margin?: string }>`
  width: fit-content;
  height: 34px;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  opacity: 0px;
  background-color: #fffaeb;
  border: 1px solid #ffbc0d;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: ${(p) => p.$margin || "0px"};
  font-family: NarkisBlock;
  font-size: 16px;
  font-weight: 400;
  line-height: 17.6px;
  letter-spacing: 0.015em;
  text-align: right;
  color: black;
  .currency {
    font-size: 12px;
    font-weight: 400;
    line-height: 13.2px;
    letter-spacing: 0.015em;
    text-align: right;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
    font-weight: 400;
    line-height: 19.8px;
    letter-spacing: 0.015em;
    text-align: right;
    .currency {
      font-size: 16px;
      line-height: 17.6px;
    }
  }
`

const StyledIconBox = styled.span`
  transform: translateY(6%) scale(0.9095);
`

interface DiscountTagProps extends HTMLAttributes<HTMLDivElement> {
  text: string
  margins?: string
}

const DiscountTag: React.FC<DiscountTagProps> = ({
  text,
  margins,
  ...props
}) => {
  const textTransform = (text: string) => {
    const textWithoutGiftEmoji = text.replace("🎁", "")
    return textWithoutGiftEmoji.replace("₪", "<span class='currency'>₪</span>")
  }
  const transformedText = textTransform(text)

  return (
    <StyledDiscountTag $margin={margins} {...props}>
      {text.includes("🎁") && <StyledIconBox>🎁</StyledIconBox>}
      <p dangerouslySetInnerHTML={{ __html: transformedText }} />
    </StyledDiscountTag>
  )
}

export default DiscountTag
